import { render, staticRenderFns } from "./DonorIdentificationFilter.vue?vue&type=template&id=4932e9d2"
import script from "./DonorIdentificationFilter.vue?vue&type=script&lang=js"
export * from "./DonorIdentificationFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports